// extracted by mini-css-extract-plugin
export var contact__title = "contact-module--contact__title--Ela5o";
export var contact__subtitle = "contact-module--contact__subtitle--KbnYW";
export var contact__text = "contact-module--contact__text--Yhdxn";
export var contact__link = "contact-module--contact__link--Fk6C7";
export var contact__linkWrapper = "contact-module--contact__link-wrapper--QXmn-";
export var contact__linkIcon = "contact-module--contact__link-icon--RkGxe";
export var contact__form = "contact-module--contact__form--mDuHJ";
export var contact__formNote = "contact-module--contact__form-note--0kKZJ";
export var contact__container = "contact-module--contact__container---x6NB";